import React from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router';
import { Share2Icon } from '@radix-ui/react-icons';
import styled from 'styled-components';
import { ElevatedButton } from '@producer/ui-kit';

import { ScreenHeader } from '../../projects/components/screen-header';
import { CommonFileBreadcrumb } from '../components/common-file-breadcrumb';
import { AssetViewerScreen } from './asset-viewer.screen';
import { FolderView } from '../components/folder-view';
import { ScreenContainer } from '../../projects/components/styled-project-components';
import { openModal } from '../../../core/modal/open-modal';
import { ShareModal } from '../../share/components/share-modal';
import { Asset } from '../../../app/entities/asset';

import type { Step } from '../../../app/entities/step';

type CommonFileScreenProps = {
  step: Step;
  spaceId: string;
};

export const CommonFileScreen: React.FC<CommonFileScreenProps> = observer(({ step, spaceId }) => {
  const { assetId } = useParams();

  const asset = Asset.getOne(assetId!);

  if (!asset) {
    return <div />; // TODO: handle display file not found placeholder
  }

  const handleOpenShareModal = async () => {
    openModal(ShareModal, {
      title: `Share ${asset.name}`,
      elementIds: [asset._id],
      spaceId: spaceId,
      projectId: step.projectId,
    });
  };

  return (
    <React.Fragment>
      <ScreenHeader
        breadcrumb={<CommonFileBreadcrumb step={step} assetId={assetId!} />}
        stepId={step._id}
        title={step.name}
        dueDate={step.dueDate}
        startDate={step.startDate}
        handleUpdateTimeFrame={(values) => step.update(values)}
        canValidateStep={false}
        actions={[
          <React.Fragment key="share-button">
            {asset && (
              <ElevatedButton onClick={handleOpenShareModal} text="Share" icon={<Share2Icon />} />
            )}
          </React.Fragment>,
        ]}
      />

      <Content>
        {asset.type === 'folder' ? (
          <FolderView stepId={step._id} folderId={asset._id} />
        ) : (
          <AssetViewerScreen asset={asset} />
        )}
      </Content>
    </React.Fragment>
  );
});

const Content = styled(ScreenContainer)`
  max-height: calc(100% - 4rem);
`;
